export default "__VITE_ASSET__10430a5d__"